import translator from '@Components/Utilities/Translator';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import TranslationText from '@Components/Utilities/TranslationText';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import TowingCapacityCalculator from '@Components/TowingGuide/TowingCapacityCalculator';
import { toTitleCase } from '@Components/Utilities/SandhillsUtility';
import WizardBanner from '@Components/Wizard/WizardBanner';

const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

const TowingGuideView = (props) => {

    const windowSize = useWindowSize();
    const resultsRef = useRef({})

    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [results, setResults] = useState([]);
    const [searchTruckCampers, setSearchTruckCampers] = useState(false);
    const [showTruckCamperOption, setShowTruckCamperOption] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [loadingResults, setLoadingResults] = useState(false); 
    const [truckCamper, setTruckCamper] = useState(false); 

    const toggleFeedbackModal = () => {
        setShowFeedbackModal(showFeedbackModal => !showFeedbackModal);
    }

    const setTowingResults = (data, truckCamper, reset) => {
        setTruckCamper(truckCamper);
        setShowResults(!reset);
        if (data && data?.length > 0) {
            if (data[0]?.VehicleType?.toLowerCase() == 'truck') {
                setShowTruckCamperOption(true);
            }
            else {
                setShowTruckCamperOption(false);
            }
            if (windowSize.isMobile) {
                scrollToResults();
            }
        }
        setResults(data);
        setLoadingResults(false);
    }

    const handleTruckCampersClick = () => {
        setLoadingResults(true); 
        setSearchTruckCampers(!searchTruckCampers);
    }

    const scrollToResults = () => {
        if (resultsRef.current) {
            resultsRef.current.scrollIntoView();
        }
    };

    const getLookingForText = () => {
        const text = truckCamper ? translator.translate('sandhills.rvtowingguidesection3search5') : translator.translate('sandhills.rvtowingguidesection3search4');
        const parts = text.split('{0}');
        return (
            <span className='results-title-looking'>
                {parts[0]}
                <Button
                    variant='text'
                    style={{
                        color: 'black',
                        backgroundColor: 'transparent',
                        fontSize: '14px',
                        textDecoration: 'underline',
                        fontWeight: 'normal',
                        padding: '0', 
                        verticalAlign: 'baseline'
                    }}
                    role='button'
                    onClick={handleTruckCampersClick}
                >
                    {toTitleCase(translator.translate('sandhills.tradepubwebsite.mvc.clickhere'))}
                </Button>
                {parts[1]}
            </span>
        );
    }
 
    return (
        <div className='towing-guide'>
            <div className={props.IsHostedSite ? 'main-hs white-bg' : 'main white-bg'}>
                <div className='container'>
                    {!props.IsHostedSite &&
                        <div className='towing-guide-breadcrumbs-media-div'>
                            <div className='towing-guide-breadcrumbs'>
                                {props.Breadcrumbs?.length > 0 &&
                                    <ComplexBreadcrumb BreadCrumbModels={props.Breadcrumbs} />
                                }
                            </div>
                        </div>}
                    <div className='towing-guide-page-header'>
                        <h1>{props.PageHeader}</h1>
                        {!props.IsHostedSite &&
                            <div className='towing-guide-feedback-button'>
                                <Button className='feedback' onClick={toggleFeedbackModal}><TranslationText tKey='sandhills.haveaquestion' /></Button>
                            </div>}
                    </div>
                    <div className='towing-guide-section-1'>
                        <div className='text flex-col'>
                            <p dangerouslySetInnerHTML={{ __html: props.SectionOneText }}></p>
                        </div>
                        <div className='section-1-image flex-col'>
                            <img src={props.ImagePath} alt='' />
                        </div>
                    </div>
                </div>

            </div>
            {!props.IsHostedSite &&(
                <div className='main grey-bg'> 
                    <div className='container'>
                        <WizardBanner WizardURL={props.WizardURL} />
                    </div>
                </div>
            )}
            <div className={props.IsHostedSite ? 'main-hs white-bg' : 'main white-bg'}>
                <div className='container'>
                    <h2><TranslationText tKey='sandhills.whatismyvehiclesmaxload' /></h2>
                    <div className='text'>
                        <p dangerouslySetInnerHTML={{ __html: props.SectionTwoText }}></p>
                    </div>
                    <ul className='bullet-list'>
                        {props.BulletPoints && props.BulletPoints.map((point, index) => (
                            <li key={'bullet' + index}><CheckCircleOutlineIcon className={'tg-check-icon'} />{point}</li>))}
                    </ul>
                </div>
            </div>

            <div className={props.IsHostedSite ? 'main-hs grey-bg' : 'main grey-bg'}>
                <div className='container'>
                    <h2><TranslationText tKey='sandhills.whatismyvehiclestowingcapacity' /></h2>
                    <div className='text'>
                        <p><TranslationText tKey='sandhills.rvtowingguidesection3' /></p>
                    </div>
                    <div className='form-container'>
                        <div className='form-search'>
                            <TowingCapacityCalculator {...props} setTowingResults={setTowingResults} searchTruckCampers={searchTruckCampers} />
                        </div>
                        <div className='form-results'>
                            {showResults ?
                                <div className='results-box' ref={resultsRef}>
                                    <div className='results-title'>
                                        {truckCamper ?
                                            <>
                                                <strong className='results-title-showing'>{translator.translate('sandhills.showingmaxpayloadfortruckcampers')}</strong>
                                                <br />
                                                {getLookingForText()}
                                            </> :
                                            <>
                                                <strong className='results-title-showing'><TranslationText tKey='sandhills.rvtowingguidesection3search3' /></strong>
                                                <br />
                                                {showTruckCamperOption &&
                                                    getLookingForText()}
                                            </>
                                        }
                                    </div>
                                    {loadingResults &&
                                        <div>
                                            <CircularProgress />
                                        </div>
                                    }
                                    {!loadingResults && results && results?.length > 0 ?
                                        <div className='results-table'>
                                            <table>
                                                {!windowSize.isMobile &&
                                                    <thead>
                                                        <tr>
                                                            <th><TranslationText tKey='sandhills.myvehicle' /></th>
                                                            <th><TranslationText tKey='sandhills.crm.dscrm.trim' /></th>
                                                            <th>{truckCamper ? translator.translate('sandhills.maxpayload') : translator.translate('sandhills.towweightrating')}
                                                                <a href={truckCamper ? '#payload' : '#twr'} aria-label={translator.translate('sandhills.crm.dscrm.definition')} style={{ marginLeft: '5px' }}><i className="fa-regular fa-circle-question"></i></a>
                                                            </th>
                                                            <td></td>
                                                        </tr>
                                                    </thead>
                                                }
                                                <tbody>
                                                    {results && results?.map((result, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <div>
                                                                    {windowSize.isMobile ?
                                                                        <>
                                                                            <div>
                                                                                <strong>{translator.translate('sandhills.myvehicle')}:</strong></div>
                                                                            <div>{result.Vehicle}</div>
                                                                        </> :
                                                                        result.Vehicle}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    {windowSize.isMobile ?
                                                                        <>
                                                                            <div>
                                                                                <strong>{translator.translate('sandhills.crm.dscrm.trim')}:</strong></div>
                                                                            <div>{result.Trim}</div>
                                                                        </> :
                                                                        result.Trim}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    {windowSize.isMobile ?
                                                                        <>
                                                                            <div>
                                                                                <strong>{truckCamper ? translator.translate('sandhills.maxpayload') : translator.translate('sandhills.towweightrating')}:</strong></div>
                                                                            <div>{result.TowingCapacity}</div>
                                                                        </> :
                                                                        result.TowingCapacity}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <Button className='towing-capacity-listings-btn' href={result.SearchURL} target='_blank' aria-label={(truckCamper ? "Search for Truck Campers" : translator.translate('sandhills.searchrvicantow')) + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{truckCamper ? <span>Search for Truck Campers</span> : <TranslationText tKey='sandhills.searchrvicantow' />}</Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div> :
                                        (!loadingResults &&
                                            <div>
                                                {translator.translate('sandhills.nodatafound')}
                                            </div>)
                                    }
                                </div>
                                :
                                <div className='results-box'>
                                    <p><TranslationText tKey='sandhills.rvtowingguidesection3search1' /></p>
                                    <p style={{ fontSize: '14px' }}><TranslationText tKey='sandhills.rvtowingguidesection3search2' /></p>
                                </div>}
                        </div>
                    </div>
                </div>

            </div>

            <div className={props.IsHostedSite ? 'main-hs grey-bg' : 'main grey-bg'}>
                <div className='container'>
                    <h2 id='rv-towing-glossary'><TranslationText tKey='sandhills.rvtowingglossary' /></h2>
                    <div className='glossary'>
                        {props.RVTowingGlossary && Object.entries(props.RVTowingGlossary).map(([key, value]) => (
                            <p id={key == translator.translate('sandhills.trailerweightrating') ? 'twr' : key.replace(" ", "-").toLowerCase()} key={key}>
                                <strong>{key}</strong>
                                {value}
                            </p>
                        ))}
                    </div>
                </div>
            </div>

            {showFeedbackModal &&
                <FeedbackModal
                    {...props.FeedbackModel} toggleModal={toggleFeedbackModal} title={translator.translate('sandhills.mobileapps.sendfeedback')} />}
        </div>);
};
export default TowingGuideView;
global.TowingGuideView = TowingGuideView;